import { Pie, PieChart, ResponsiveContainer } from 'recharts'

const RADIAN = Math.PI / 180

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, name }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * Math.cos(-midAngle * RADIAN) * 0.6
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text
      x={x}
      y={y}
      fill="#2D2D6C"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {percent > 0 && name ? `${name}: ${(percent * 100).toFixed(0)}%` : '0%'}
    </text>
  )
}

const DonutChart = props => (
  <ResponsiveContainer width="100%" height={200}>
    <PieChart width="100%" height="100%">
      <Pie
        cx="50%"
        cy="50%"
        labelLine={false}
        innerRadius={30}
        outerRadius={100}
        label={renderCustomizedLabel}
        {...props}
      />
    </PieChart>
  </ResponsiveContainer>
)

export default DonutChart
